export default "__VITE_ASSET__Hr2HUuch__"